import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import classNames from "classnames";
import { JoyRide } from "components/molecules/JoyRide";
import { useScreenSize } from "hooks";
import { segmentReFetchContext } from "context";
import { AIMCATChat } from "../../organisms/AiMcatChat";
import { Sidebar } from "components/organisms/Sidebar";
import { AppFooter } from "components/organisms/AppFooter";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

interface SelectedBtnState {
  [key: string]: boolean;
  "1": boolean;
  "2": boolean;
  "3": boolean;
  "4": boolean;
}

export const MainPage = ({ theme }: IProps) => {
  const screen = useScreenSize();

  const [selectedBtn, setSelectedBtn] = useState<SelectedBtnState>({
    "1": true,
    "2": false,
    "3": false,
    "4": false,
  });

  const [selectedSession, setSelectedSession] = useState<
    null | string | { [key: number]: string }
  >({ 0: "Recent and Upcoming Sessions" });

  const [data, setData] = useState<any[]>([]);

  const [page, setPage] = useState<number>(1);

  const mainWrapperRef = useRef<any>(null);

  const location = useLocation();

  useEffect(() => {
    mainWrapperRef.current.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className={classNames("main-page-wrapper")}>
      <JoyRide />
      <Sidebar theme={theme} />

      <div
        ref={mainWrapperRef}
        className={classNames({
          "content-section-wrapper": true,
          "custom-bg-color":
            location.pathname === "/" ||
            location.pathname === "/study-recommendations-tool",
        })}
      >
        <div
          className={classNames({
            "main-page-detail-section": true,
            "custom-bg-color":
              location.pathname === "/" ||
              location.pathname === "/study-recommendations-tool",
          })}
        >
          <segmentReFetchContext.Provider
            value={{
              data,
              setData,
              selectedBtn,
              setSelectedBtn,
              selectedSession,
              setSelectedSession,
              page,
              setPage,
            }}
          >
            <div className="page-content-fill">
              <Outlet />
            </div>
          </segmentReFetchContext.Provider>
          <AppFooter />
        </div>
      </div>
      {/*  here defines the AI MCAT chat drawer and error alert*/}
      <AIMCATChat theme={theme} />
    </div>
  );
};
